export const SCHEDULE_DETAIL_SIDEBAR_WIDTH_PX = 400;
export const SCHEDULE_DETAIL_DESKTOP_MIN_WIDTH_PX = 1280;
export const SCHEDULE_DETAIL_TRANSITION_MS = 220;
/** Above app header (styled-components header uses z-index: 1000). */
export const SCHEDULE_DETAIL_SIDEBAR_Z_INDEX = 1100;
export const SCHEDULE_DETAIL_BACKDROP_Z_INDEX = 1050;

export function applyScheduleDetailSidebarBodyOffset(active: boolean): void {
  if (typeof document === "undefined") {
    return;
  }

  if (active) {
    document.body.style.paddingRight = `${SCHEDULE_DETAIL_SIDEBAR_WIDTH_PX}px`;
    document.body.style.overflowX = "hidden";
    return;
  }

  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("overflow-x");
}
